import { H2, H4 } from '@common/headline';
import { SeparatedGrid } from '@components/SeparatedGrid/SeparatedGrid';
import Icon from '@common/Icons/Icon';

export const TransformOutcomes = (): JSX.Element => (
  <div className="bg-white px-8 py-16 lg:px-[60px] lg:pb-[130px] lg:pt-[104px]">
    <SeparatedGrid
      borderColour="border-dawn-blue"
      heading={
        <div className="mb-[70px] flex flex-col justify-center text-center text-blue lg:mb-[45px] lg:px-[260px]">
          <div className="pb-4">
            <H2>
              <span className="text-salmon">Transform</span> health outcomes
            </H2>
          </div>
          <H4>
            NHS commissioners and health insurers use our proven services to
            support weight loss, physical activity, nutrition, type 2 diabetes
            prevention, type 2 diabetes management, and mental wellbeing
          </H4>
        </div>
      }
      content={[
        <div
          key="1"
          className="mx-auto flex max-w-[312px] flex-col items-center text-center text-blue lg:mr-6"
        >
          <div className="pb-4">
            <Icon name="doctors" />
          </div>

          <H4>
            Second Nature services are used by more than half of all NHS Health
            and Care boards in the UK.
          </H4>
        </div>,
        <div
          key="2"
          className="mx-auto mt-8 flex max-w-[312px] flex-col items-center text-center text-blue lg:mr-6 lg:mt-0"
        >
          <div className="pb-4">
            {/* Do not reuse this icon due to the NHS logo guidelines, we will be replacing existing usage with a new icon */}
            <Icon name="backedByNhs" />
          </div>
          <H4>
            The first app-based behaviour change service to be commissioned by
            the NHS
          </H4>
        </div>,
        <div
          key="3"
          className="mx-auto mt-8 flex max-w-[312px] flex-col items-center text-center text-blue lg:mt-0"
        >
          <div className="pb-4">
            <Icon name="medal" />
          </div>
          <H4>
            People maintain 6.2kg weight loss and 40% reduce HbA1c below the
            type 2 diabetes threshold
          </H4>
        </div>,
      ]}
    />
  </div>
);
